import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

export async function fetchStockIssueCategoryList(listQuery) {
  const { data: raw } = await request.get('/system/stock-issue-category', {
    params: listQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
